// extracted by mini-css-extract-plugin
module.exports = {"productDisplayPayLater":"PayLater_productDisplayPayLater__hsGzr","payLaterInfo":"PayLater_payLaterInfo__nosRQ"};